import React from "react"
import { Container, Card, ThreeLine, Text, LastText, Thumbnail, Rating, Title, Subtitle, lastLine } from "./styles/skeleton"

export default function Skeleton() {
  return <Container></Container>
}

Skeleton.Title = function SkeletonText() {
  return <Title></Title>
}

Skeleton.MovieCard = function MovieSkeleton() {
  return (
    <Card>
      <Thumbnail>
        <Rating></Rating>
      </Thumbnail>
      <Title></Title>
      <Subtitle></Subtitle>
    </Card>
  )
}

Skeleton.Subtitle = function SkeletonText() {
  return <Subtitle></Subtitle>
}
Skeleton.Thumbnail = function SkeletonText() {
  return <Thumbnail></Thumbnail>
}

Skeleton.LastLine = function SkeletonText() {
  return <lastLine></lastLine>
}

Skeleton.SingleLine = function SkelotonThree({ w, type }) {
  return (
    <ThreeLine w={w}>
      <Text type={type}></Text>
    </ThreeLine>
  )
}

Skeleton.ThreeLine = function SkelotonThree({ w }) {
  return (
    <ThreeLine w={w}>
      <Text></Text>
      <Text></Text>
      <Text></Text>
      <LastText></LastText>
    </ThreeLine>
  )
}
